import { Pipe, PipeTransform } from '@angular/core';
import { UserStatus } from '../../interfaces/user';

@Pipe({
  name: 'userStatus'
})
export class UserStatusPipe implements PipeTransform {

  transform(value: UserStatus): string {
    switch (value) {
      case UserStatus.PENDING:
        return 'Pendente';
      case UserStatus.ACTIVE:
        return 'Ativo';
      case UserStatus.INACTIVE:
        return 'Inativo';
      default:
        return '---';
    }
  }

}
